import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { formatNumber } from "../../utils";
import { TAX_REPORT_PARTY_LABEL, TaxReportKind } from "./constants";
import { gridHeadCellSx, gridHeadSx } from "./gridStyles";
import { TaxReportRow } from "./taxReport";

interface TaxTabProps {
  kind: TaxReportKind;
  /** null while the document carries no VAT. */
  row: TaxReportRow | null;
}

const COLUMN_COUNT = 10;

/**
 * รายการภาษีซื้อ / รายการภาษีขาย — read-only: worked out from the header and the totals, the
 * line this document puts on the tax report.
 */
export default function TaxTab({ kind, row }: Readonly<TaxTabProps>) {
  return (
    <TableContainer>
      <Table size="small">
        <TableHead sx={gridHeadSx}>
          <TableRow>
            <TableCell sx={gridHeadCellSx}>ยื่นรวม</TableCell>
            <TableCell sx={gridHeadCellSx} colSpan={2} align="center">
              ใบกำกับภาษี
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2}>
              แผนก
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2}>
              คำนำหน้า
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2}>
              {TAX_REPORT_PARTY_LABEL[kind]}
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2}>
              TaxID (13 หลัก)
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2} align="right">
              สาขา#
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2} align="right">
              มูลค่า
            </TableCell>
            <TableCell sx={gridHeadCellSx} rowSpan={2} align="right">
              ภาษี
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={gridHeadCellSx}>ในงวด</TableCell>
            <TableCell sx={gridHeadCellSx}>วันที่</TableCell>
            <TableCell sx={gridHeadCellSx}>เลขที่</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {row ? (
            <TableRow>
              <TableCell>{row.period}</TableCell>
              <TableCell>{row.date}</TableCell>
              <TableCell>{row.docNo}</TableCell>
              <TableCell>{row.departmentCode}</TableCell>
              <TableCell>{row.title}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.taxId}</TableCell>
              <TableCell align="right">{row.taxBranchNo}</TableCell>
              <TableCell align="right">{formatNumber(row.baseAmount)}</TableCell>
              <TableCell align="right">{formatNumber(row.vatAmount)}</TableCell>
            </TableRow>
          ) : (
            <TableRow>
              <TableCell colSpan={COLUMN_COUNT} align="center" sx={{ py: 4 }}>
                <Typography variant="body2" color="text.secondary">
                  เอกสารนี้ไม่มี VAT จึงไม่มีรายการภาษี
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
